var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTopMenu = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 3H21C21.8284 3 22.5 3.67157 22.5 4.5V7.5H1.5V4.5C1.5 3.67157 2.17157 3 3 3ZM24 4.5C24 2.84315 22.6569 1.5 21 1.5H3C1.34315 1.5 0 2.84315 0 4.5V19.5C0 21.1569 1.34315 22.5 3 22.5H21C22.6569 22.5 24 21.1569 24 19.5V4.5ZM1.5 19.5V9H22.5V19.5C22.5 20.3284 21.8284 21 21 21H3C2.17157 21 1.5 20.3284 1.5 19.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 4.5H4.5V6H3V4.5Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 4.5H12V6H9V4.5Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 4.5H16.5V6H13.5V4.5Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M18 4.5H21V6H18V4.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTopMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/top-menu.dd60b48fc095bc207c816eada9029960.svg";